<ng-container [ngSwitch]="triggerType">
  <div
    *ngSwitchCase="TriggerTypes.Button"
    class="toggle-control form-control form-control-sm form-control"
    #menuTrigger="matMenuTrigger"
    [matMenuTriggerFor]="disableTrigger ? null : menu"
    [class.open]="menuTrigger.menuOpen"
  >
    <capra-icon class="chart-type-selected-icon" [icon]="selectedIcon" height="40px" width="45px"></capra-icon>
    <div class="display">
      {{ selectedChartCategory }}
      <span class="selected-chart-name" *ngIf="selectedChartName">{{ selectedChartName }}</span>
    </div>
    <capra-icon class="select-icon" icon="icon-chevron"></capra-icon>
  </div>
  <span *ngSwitchCase="TriggerTypes.Chevron">
    <capra-icon class="ds-gray-900" icon="icon-chevron" [matMenuTriggerFor]="disableTrigger ? null : menu"></capra-icon>
  </span>
  <div *ngSwitchDefault #menuTrigger="matMenuTrigger" [matMenuTriggerFor]="disableTrigger ? null : menu">
    <ng-content></ng-content>
  </div>
</ng-container>
<mat-menu class="toggle-menu" #menu="matMenu" [overlapTrigger]="overlapTrigger" (closed)="onMenuClosed()">
  <div mat-menu-item class="toggle-menu-item">
    <div class="toggle-menu-item-text">
      <div class="toggle-menu-item-heading">Visual Explorer</div>
    </div>
  </div>
  <div class="chart-picker-container viz-explorer-container">
    <button
      class="chart-type-icon visual-explorer-icon"
      data-test="vegas-visual-explorer"
      mat-menu-item
      (click)="selectVizExplorer()"
      capraTooltip
      [tooltipContent]="visualExplorerTooltip"
      [tooltipContentIsHtml]="true"
      tooltipSize="regular"
      tooltipPlacement="bottom"
      [tooltipInteractive]="tooltipInteractive"
    >
      <capra-icon icon="illo-visual-explorer"></capra-icon>
      <ng-container *ngIf="selectedChartType?.id === 'vegas'">
        <capra-icon class="stroked" icon="icon-check"></capra-icon>
        <capra-icon icon="icon-check"></capra-icon>
      </ng-container>
    </button>
  </div>
  <div class="toggle-menu-item mat-menu-item quick-chart-heading">
    <div class="toggle-menu-item-text quick-charts-menu-item">
      <div class="toggle-menu-item-heading">Quick charts</div>
    </div>
  </div>
  <div class="chart-picker-container">
    <ng-container *ngFor="let chartType of chartTypes; trackBy: trackByFn">
      <button
        *ngIf="!chartType.hidden"
        class="chart-type-icon"
        attr.data-test="{{ chartType.id }}"
        mat-menu-item
        (click)="selectChart(chartType)"
        capraTooltip
        [tooltipContent]="chartType.name"
        tooltipSize="mini"
        tooltipPlacement="bottom"
        [tooltipInteractive]="tooltipInteractive"
      >
        <capra-icon [icon]="chartType.icon"></capra-icon>
        <ng-container *ngIf="selectedIcon === chartType.icon">
          <capra-icon class="stroked" icon="icon-check"></capra-icon>
          <capra-icon icon="icon-check"></capra-icon>
        </ng-container>
      </button>
    </ng-container>
  </div>
  <!-- Legacy Chart Options -->
  <div *ngIf="isLocal !== false && hasLegacyChart()">
    <div class="legacy-charts-header">Legacy charts with limited features</div>
    <div class="chart-picker-container legacy-charts-container">
      <ng-container *ngFor="let chartType of legacyChartTypes; trackBy: trackByFn">
        <button
          *ngIf="!chartType.hidden"
          class="chart-type-icon"
          attr.data-test="{{ chartType.id }}"
          mat-menu-item
          [class.disabled]="chartType.disabled"
          (click)="!chartType.disabled && selectChart(chartType)"
          capraTooltip
          [tooltipContent]="chartType.name"
          tooltipSize="mini"
          tooltipPlacement="bottom"
          [tooltipInteractive]="tooltipInteractive"
        >
          <capra-icon [icon]="chartType.icon" height="40px" width="40px"></capra-icon>
        </button>
      </ng-container>
    </div>
  </div>
</mat-menu>
